import { fetchWithOptions } from 'Utility/fetch';
import { getJWTData, parseJWTFromCookie } from 'Utility/jwtAuthTools';
import { ActionableErrorContext, Loggable, makeLog } from 'Utility/logger';

export const search = async (searchString: string, wildcard: string): Promise<IExtendedSearchResults[] | null> => {
  const orgid = getJWTData()?.orgid;
  if (!orgid) return null;
  return fetchWithOptions(
    `/api/patient/v2/search/${orgid}?search=${searchString}&wildcard=${wildcard}`,
    { neurojwt: parseJWTFromCookie() },
    { method: 'GET' },
  )
    .then(
      (res: Response) => {
        if (res.status === 200) {
          return res.json();
        } else {
          throw new Error('unexpected status ' + res.status);
        }
      },
      (error: unknown) => {
        throw error;
      },
    )
    .catch((err: unknown) => {
      makeLog(Loggable.BugActionable, err, new ActionableErrorContext(null, 'search patient'));
      return null;
    });
};

export const extendedSearch = async (searchString: string): Promise<IExtendedSearchResults[] | null> => {
  const orgid = getJWTData()?.orgid;
  if (!orgid) return null;
  return fetchWithOptions(
    `/api/advancedsearch/query/${orgid}?` + searchString,
    {
      neurojwt: parseJWTFromCookie(document.cookie),
    },
    { method: 'GET' },
  )
    .then(
      (res: Response) => {
        if (res.status === 200) {
          return res.json();
        } else {
          throw new Error('unexpected status ' + res.status);
        }
      },
      (error: unknown) => {
        throw error;
      },
    )
    .then((results: Array<IExtendedSearchResults & { ssnLocale?: string }>) =>
      // The advanced search API returns the locale field as 'ssnLocale' unlike the patient search API
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      results.map(({ ssnLocale, ...rest }) => ({ ...rest, ssnLocalization: rest.ssnLocalization ?? ssnLocale ?? '' })),
    )
    .catch((err: unknown) => {
      makeLog(Loggable.BugActionable, err, new ActionableErrorContext(null, 'advanced search'));
      return null;
    });
};
